import * as React from "react"
import {Grid} from "@mui/material";

import PricingEvolutionSkuInfo from "./Info";


export default function PricingEvolutionSkuBlock({ currentSku,currentSkuSelected }) {
    return <Grid container spacing={1}>
		<Grid item xs={12}>
			<PricingEvolutionSkuInfo currentSku={currentSku} currentSkuSelected={currentSkuSelected} />
		</Grid>
    </Grid>
}